<template>
    <div class="main">
		<div v-show="!detialshow">
			<Search ref="searchref">
				<template v-slot:btns>
					<a-form-model-item>
						<a-button type="primary" @click="getlist({current:1})">查询</a-button>
					</a-form-model-item>
					<a-form-model-item>
						<a-button type="primary" @click="muldelfn">批量删除</a-button>
					</a-form-model-item>
					<ExprotExcel :getpagedata="getdatasource" :getsearchdata="getsearchdata"></ExprotExcel>
				</template>
			</Search>
			<SumComponent :sum="sum" :psum="psum"></SumComponent>
			<Table ref="tableref">
				<template v-slot:tAction="{id,record}">
					<div style="width:120px">
						<a class="tAction" @click="godetial(id)"><a-icon type="vertical-align-bottom" /> 查看导出</a>
						<template v-if="record.isMoneyGive==0 && record.type != 4 && record.type != 8 && record.type != 9">
							<a-divider type="vertical" />
							<a class="tAction" @click="bokuan(id)">拨款</a>
						</template>
						<a-divider type="vertical" />
						<a type="primary" @click="delfn(id)">删除</a>
					</div>
				</template>
			</Table>
			<Pagination :current="current" :pageSize="pageSize" :total="total" :pageChange="pageChange" :pageSizeChange="pageSizeChange"></Pagination>
		</div>
		<div v-if="detialshow">
			<Detial :id="detialId" @backfn="backdetial"></Detial>
		</div>
   </div>
</template>

<script>
import Search from './search';
import Table from './table';
import Detial from '@/components/Detial/index.vue'
import Pagination from "@/components/curd/pagination"
import PageData from "@/components/curd/pagination/data.js"
import {getContractList,deleteContract,muldel,updateContract,exportall,getCailiaodanlist} from "@/api/contract.js"
import deleteData from '@/components/curd/delete.js';
import { message } from 'ant-design-vue';
import ExprotExcel from "./exportexcel.vue"
import SumComponent from './sum';

	export default{
		data(){
			return {
				detialId:-1,
				detialshow:false,
				sum:{},
				psum:{}
			}
		},
		methods:{
			getsearchdata(){
				let searchdata = this.$refs.searchref.getformdata()
				return searchdata
			},
			getlist(parm){
				let dd = {status:"3",type:"7",...this.getsearchdata(),current:this.current,pageSize:this.pageSize,...parm}
				this.$refs.tableref.getlist(dd).then(ret=>{
					let {data,sum,psum} = ret
					this.sum = sum
					this.psum = psum
					this.total = data.count
					this.current = dd.current
					this.pageSize = dd.pageSize
				})
			},
			getdatasource(){
				return this.$refs.tableref.getdataSource()
			},
			delfn(id){
				this.deletefn(()=>{
					return deleteContract({id}).then(ret=>{
						if(ret.code == 0){
							this.getlist()
							return "success"
						}else{
							return "erro"
						}
					})
				})
			},
			muldelfn(){
				let ids = this.$refs.tableref.getSlts()
				this.muldelete(ids,()=>{
					return muldel({ids:JSON.stringify(ids)}).then(ret=>{
						if(ret.code == 0){
							this.getlist()
							this.$refs.tableref.setSlts([])
							return "success"
						}else{
							return "erro"
						}
					})
				})
			},
			godetial(id){
				this.detialId = id
				this.detialshow = true
			},
			backdetial(){
				this.detialshow = false
			},
			bokuan(id){
				this.$confirm({
					title:"操作确认提示",
					content:"您确定要置为【已拨款】",
					okText:"确定",
					cancelText:"取消",
					onOk:()=>{
						message.loading({content:"正在提交修改...",key:"bokuan"})
						updateContract({id,isMoneyGive:1}).then(ret=>{
							if(ret.code == 0){
								this.getlist()
								message.success({content:"操作成功",key:"bokuan",duration:2})
							}
						})
					}
				})
			},
		},
		mounted(){
			this.getlist()
		},
		components:{Search,Table,Pagination,Detial,ExprotExcel,SumComponent},
		mixins:[PageData,deleteData]
	}
</script>

<style lang="less" scoped>
</style>
